// extracted by mini-css-extract-plugin
module.exports = {"container":"switch_container__rS7OK","error":"switch_error__38c_a","label":"switch_label__1dHRs"};